module.exports = __webpack_public_path__ + "img/trident.73791022.png";